import Vue from 'vue'
import { GET_TRAININGS, ERROR_XHR } from '../mutation-types.js'

export const getTrainings = ({ state, dispatch }) => {
  return new Promise((resolve, reject) => {
    Vue.http.get('training')
    .then(
      (response) => {
        dispatch(GET_TRAININGS, response.json())
        resolve()
      },
      (response) => {
        dispatch(ERROR_XHR, response.json())
        reject()
      }
    )
  })
}



// WEBPACK FOOTER //
// ./src/vuex/actions/trainingActions.js